import type { TextAreaProps } from 'antd/es/input/TextArea';
import TextArea from 'antd/es/input/TextArea';
import { Controller, useFormContext } from 'react-hook-form';

import { FieldValidationMessage } from '../FieldValidationMessage/FieldValidationMessage';

import styles from './Field.module.scss';

interface ITextAreaProps extends TextAreaProps {
  fieldName: string;
}

export const TextAreaField = ({ fieldName, ...restProps }: ITextAreaProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState: { invalid: isInvalid, error } }) => (
        <div className={styles['field-wrapper']}>
          <TextArea
            {...field}
            {...restProps}
            status={isInvalid ? 'error' : undefined}
          />
          {isInvalid && <FieldValidationMessage message={error?.message} />}
        </div>
      )}
    />
  );
};
